import { BASE_URL } from '../../../configs'
import { alertError, createJsonHeaders, logoutOnRequestOrResponseJson } from '../../../api'

/**
 * Starts a QCS supervision handoff for the current admin on this organisation.
 * Cookie auth (botscrew-auth-token) via credentials: 'include'.
 *
 * GET /api/private/qcs-supervision-handoff?botId={botId}
 * → { redirectUrl: "/app/supervision?type=qcs&id=<handoff>" }
 */
export function fetchQcsSupervisionHandoff(botId) {
  const id = encodeURIComponent(botId)
  return fetch(`${BASE_URL}/qcs-supervision-handoff?botId=${id}`, {
    method: 'GET',
    credentials: 'include',
    headers: createJsonHeaders(),
  }).then(logoutOnRequestOrResponseJson)
}

export function resolveHandoffRedirectUrl(payload) {
  const url =
    (payload && (payload.redirectUrl || payload.data?.redirectUrl)) || ''
  return typeof url === 'string' ? url.trim() : ''
}

export function openQcsSupervisionHandoff(botId) {
  // Open in the click turn so the browser allows a new tab after the async fetch.
  // Do not pass noopener here — it makes open() return null and blocks setting href.
  const tab = window.open('about:blank', '_blank')
  if (tab) tab.opener = null

  return fetchQcsSupervisionHandoff(botId)
    .then(payload => {
      const redirectUrl = resolveHandoffRedirectUrl(payload)
      if (!redirectUrl) {
        if (tab) tab.close()
        alertError('Supervision handoff did not return a redirect URL.')
        return
      }
      if (tab) {
        tab.location.href = redirectUrl
        return
      }
      // Popup blocked — still try a direct new-tab open (may also be blocked).
      const fallback = window.open(redirectUrl, '_blank')
      if (fallback) fallback.opener = null
    })
    .catch(err => {
      if (tab) tab.close()
      throw err
    })
}
